/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Autocomplete, Checkbox, Chip, Container, Grid } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Button, IconButton } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { ToastContainer, toast } from 'react-toastify';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Icon from '@material-ui/core/Icon';

export default function CustomerTypeMappingAddEdit() {
    const screenCode = 'CUSTOMERTYPEMAPPING';
    const navigate = useNavigate();
    const [isButtonEnable, setIsButtonEnable] = useState(false);
    const [customerTypeMappingEditingId, setCustomerTypeMappingEditingId] = useState(0);
    const [productcatogery, setProductcatogery] = useState([]);
    const [product, setProduct] = useState([]);
    const [IsClear, setIsClear] = useState(false);
    const [groupList, setGroupList] = useState([]);
    const [orderTypeList, setOrderTypeList] = useState([]);

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedOrderTypes, setSelectedOrderTypes] = useState([]);
    const [gridRows, setGridRows] = useState([]);
    const [prefilledRows, setPrefilledRows] = useState([]);
    const [deletedRows, setDeletedRows] = useState([]);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [isPrefillingEditData, setIsPrefillingEditData] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState({
        open: false,
        mappingId: 0,
        rowIndex: null
    });

    const [backConfirmOpen, setBackConfirmOpen] = useState(false);

    const toIsoDateOnly = (value) => {
        const fallback = new Date();
        if (value === null || value === undefined || value === '') {
            return fallback.toISOString().split('T')[0];
        }
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) {
            return fallback.toISOString().split('T')[0];
        }
        return d.toISOString().split('T')[0];
    };

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add SKU-Customer Type Mapping"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });

    const validationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Group is required').required('Group is required'),
        orderTypeIDs: Yup.array().min(1, 'Customer Order Type is required').required('Customer Order Type is required'),
        productCategoryID: Yup.number().min(1, 'Product Category is required').required('Product Category is required'),
    });

    const { customerTypeMappingId } = useParams();
    let decrypted = 0;

    useEffect(() => {
        decrypted = AESDecryptionParam(customerTypeMappingId);
        if (decrypted > 0) {
            setPageProps((prev) => ({
                ...prev,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit SKU-Customer Type Mapping"
            }));
            setCustomerTypeMappingEditingId(decrypted);
            GetCustomerTypeDetaildByID(decrypted);
        }
    }, []);

    const formik = useFormik({
        initialValues: {
            groupID: 0,
            productCategoryID: 0,
            orderTypeIDs: [],
        },

        validationSchema: validationSchema,
        onSubmit: (values) => {
            trackPromise(submitCustomerTypeMapping(values));
        }
    });

    async function GetCustomerTypeDetaildByID(mappingId) {
        setIsPrefillingEditData(true);
        const result = await services.GetCustomerTypeDetaildByID(mappingId);
        const payload = result?.data ?? result;


        let records = [];
        if (Array.isArray(payload)) {
            records = payload.map((r) => ({
                ...r,
                customerTypeMappingID: r.customerTypeMappingID ?? mappingId,
            }));
        } else if (payload && Array.isArray(payload.products)) {
            records = payload.products.map((p) => ({
                customerTypeMappingID: p.customerTypeMappingID ?? payload.customerTypeMappingID ?? mappingId,
                groupID: payload.groupID,
                groupName: payload.groupName,
                productCategoryID: payload.productCategoryID,
                productCategoryName: payload.productCategoryName,
                orderTypeID: payload.orderTypeID,
                orderTypeName: payload.orderTypeName,
                productID: p.productID,
                productName: p.productName
            }));
        } else if (payload && typeof payload === 'object' && payload.productID) {
            records = [
                {
                    ...payload,
                    customerTypeMappingID: payload.customerTypeMappingID ?? mappingId,
                }
            ];
        }

        if (records.length === 0) {
            toast.error('No record found to edit');
            return;
        }

        const first = records[0];
        const uniqueOrderTypes = Array.from(
            new Map(
                records
                    .filter((r) => r?.orderTypeID)
                    .map((r) => [parseInt(r.orderTypeID), { orderTypeID: parseInt(r.orderTypeID), orderTypeName: r.orderTypeName }])
            ).values()
        );
        setSelectedOrderTypes(uniqueOrderTypes);
        setValues({
            ...values,
            groupID: parseInt(first.groupID) || 0,
            productCategoryID: parseInt(first.productCategoryID) || 0,
            orderTypeIDs: uniqueOrderTypes.map((ot) => ot.orderTypeID),
        });

        const mappedPrefilled = records.map((r) => ({
            key: `existing-${r.customerTypeProductMappingID || r.customerTypeMappingID || mappingId || ''}-${r.productID}`,
            rowState: 'existing',
            customerTypeMappingID: r.customerTypeMappingID ?? mappingId,
            customerTypeProductMappingID: r.customerTypeProductMappingID ?? null,
            date: r.date ?? r.fromDate ?? r.createdDate ?? r.createdOn ?? null,
            groupID: r.groupID,
            groupName: r.groupName,
            productCategoryID: r.productCategoryID,
            productCategoryName: r.productCategoryName,
            orderTypeID: r.orderTypeID,
            orderTypeName: r.orderTypeName,
            productID: r.productID,
            productName: r.productName
        }));

        // Bind existing record data to inputs, but do NOT show it in the grid on update screen.
        setPrefilledRows(mappedPrefilled);
        setGridRows([]);

        const uniqueSelected = Array.from(
            new Map(
                records
                    .filter((r) => r?.productID)
                    .map((r) => [parseInt(r.productID), { productID: parseInt(r.productID), productName: r.productName }])
            ).values()
        );
        setSelectedProducts(uniqueSelected);

        setDeletedRows([]);
        setEditingRowIndex(null);
        setIsPrefillingEditData(false);

    }
    async function submitCustomerTypeMapping(submitValues) {
        if (!pageProps.isEdit && gridRows.length === 0) {
            toast.error('Please add at least one product to the grid before saving');
            return;
        }

        const createdBy = parseInt(TokenDecoder.getUserIDFromToken());
        const buildSaveCustomerTypeMappingItem = (rowOrValues, overrides = {}) => {
            const groupID = parseInt(overrides.groupID ?? rowOrValues.groupID) || 0;
            const productCategoryID = parseInt(overrides.productCategoryID ?? rowOrValues.productCategoryID) || 0;
            const orderTypeID = parseInt(overrides.orderTypeID ?? rowOrValues.orderTypeID) || 0;
            const productID = parseInt(overrides.productID ?? rowOrValues.productID) || 0;
            const customerTypeMappingID = parseInt(
                overrides.customerTypeMappingID ??
                rowOrValues.customerTypeMappingID ??
                0
            ) || 0;
            const customerTypeProductMappingID = parseInt(
                overrides.customerTypeProductMappingID ??
                rowOrValues.customerTypeProductMappingID ??
                0
            ) || 0;

            return {
                customerTypeMappingID,
                customerTypeProductMappingID,
                groupID,
                productCategoryID,
                orderTypeID,
                productID,
                createdBy,
                createdDate: new Date().toISOString(),
                isActive: overrides.isActive ?? true
            };
        };
        const buildUpdateCustomerTypeMappingModel = ({
            groupID,
            orderTypeID,
            productCategoryID,
            productID,
            customerTypeMappingID,
            customerTypeProductMappingID,
            dateValue,
            isActive
        }) => {
            const model = {
                groupID: parseInt(groupID) || 0,
                orderTypeID: parseInt(orderTypeID) || 0,
                productCategoryID: parseInt(productCategoryID) || 0,
                productID: parseInt(productID) || 0,
                createdBy,
                date: toIsoDateOnly(dateValue),
                isActive: Boolean(isActive)
            };

            if (customerTypeProductMappingID !== null && customerTypeProductMappingID !== undefined) {
                const id = parseInt(customerTypeProductMappingID);
                if (!Number.isNaN(id) && id > 0) {
                    model.customerTypeProductMappingID = id;
                }
            }

            if (customerTypeMappingID !== null && customerTypeMappingID !== undefined) {
                const id = parseInt(customerTypeMappingID);
                if (!Number.isNaN(id) && id > 0) {
                    model.customerTypeMappingID = id;
                }
            }

            return model;
        };

        setIsButtonEnable(true);
        try {
            if (!pageProps.isEdit) {
                const modelList = gridRows.map((row) => buildSaveCustomerTypeMappingItem(row, { isActive: true }));
                const res = await services.SaveCustomerTypeMapping(modelList);

                if (res?.statusCode === 'Success' || (typeof res?.data === 'number' && res.data > 0)) {
                    toast.success(`Customer Type Mapping saved (${modelList.length} product(s))`);
                    formik.resetForm();
                    setGridRows([]);
                    setSelectedProducts([]);
                    setDeletedRows([]);
                    setEditingRowIndex(null);
                    setTimeout(() => {
                        navigate('/dashboard/CustomerTypeMapping');
                    }, 800);
                } else if (res?.data == -1) {
                    toast.error('Selected mappings already exist');
                } else {
                    toast.error(res?.message || 'No records were saved');
                }
            } else {
                // Edit mode: Group / Category / Product are locked. Only the SET of
                // customer order types changes for this single product.
                const currentGroupID = parseInt(submitValues.groupID) || 0;
                const currentCategoryID = parseInt(submitValues.productCategoryID) || 0;
                const originalRows = Array.isArray(prefilledRows) ? prefilledRows : [];
                const productID = parseInt(
                    (selectedProducts || [])[0]?.productID ?? originalRows[0]?.productID
                ) || 0;

                const currentTypeIds = Array.from(new Set(
                    (selectedOrderTypes || [])
                        .map((t) => parseInt(t.orderTypeID))
                        .filter((id) => !Number.isNaN(id) && id > 0)
                ));
                const originalTypeIds = Array.from(new Set(
                    originalRows
                        .map((r) => parseInt(r.orderTypeID))
                        .filter((id) => !Number.isNaN(id) && id > 0)
                ));

                if (currentTypeIds.length === 0) {
                    toast.error('At least one Customer Order Type is required');
                    return;
                }

                const addedTypeIds = currentTypeIds.filter((id) => !originalTypeIds.includes(id));
                const removedTypeIds = originalTypeIds.filter((id) => !currentTypeIds.includes(id));

                if (addedTypeIds.length === 0 && removedTypeIds.length === 0) {
                    toast.error('No changes to update');
                    return;
                }

                let deletedCount = 0;
                let createdCount = 0;
                let duplicateCount = 0;

                // Removed types: soft-delete every active row of that type
                // (handles pre-existing duplicate rows for the same combo).
                for (const typeId of removedTypeIds) {
                    const rowsOfType = originalRows.filter((r) => parseInt(r.orderTypeID) === typeId);
                    for (const row of rowsOfType) {
                        const deleteModel = buildUpdateCustomerTypeMappingModel({
                            groupID: currentGroupID,
                            orderTypeID: typeId,
                            productCategoryID: currentCategoryID,
                            productID,
                            customerTypeMappingID: row.customerTypeMappingID ?? pageProps.editingID,
                            customerTypeProductMappingID: row.customerTypeProductMappingID,
                            dateValue: row.date,
                            isActive: false
                        });
                        const res = await services.UpdateCustomerTypeMapping(deleteModel);
                        if (res?.statusCode === 'Success' || (typeof res?.data === 'number' && res.data > 0)) {
                            deletedCount++;
                        }
                    }
                }

                
                for (const typeId of addedTypeIds) {
                    const model = buildSaveCustomerTypeMappingItem(
                        {},
                        {
                            isActive: true,
                            customerTypeMappingID: 0,
                            groupID: currentGroupID,
                            productCategoryID: currentCategoryID,
                            orderTypeID: typeId,
                            productID
                        }
                    );
                    const res = await services.SaveCustomerTypeMapping([model]);
                    if (res?.statusCode === 'Success' || (typeof res?.data === 'number' && res.data > 0)) {
                        createdCount++;
                    } else if (res?.data == -1) {
                        duplicateCount++;
                    }
                }

                if (createdCount > 0 || deletedCount > 0) {
                    toast.success(`${createdCount} Records Added, ${deletedCount} Records Updated`);
                    setTimeout(() => {
                        navigate('/dashboard/CustomerTypeMapping');
                    }, 1200);
                } else if (duplicateCount > 0) {
                    toast.error('No changes saved (duplicates found)');
                } else {
                    toast.error('No changes were applied');
                    GetCustomerTypeDetaildByID(customerTypeMappingEditingId);
                }
            }
        } finally {
            setIsButtonEnable(false);
        }
    }

    async function loadProductsByCategory() {
        if (!formik.values.productCategoryID || parseInt(formik.values.productCategoryID) < 1) {
            setProduct([]);
            return;
        }
        var res = await services.GetProductDetailsByProductcatogeryID(formik.values.productCategoryID)
        if (res != null) {
            setProduct(res);
        }
    }

    async function loadCustomerOrderTypes() {
        try {
            var res = await services.GetCustomerOrderTypes();
            if (res != null) {
                setOrderTypeList(res);
            }
        } catch (error) {
            toast.error('Failed to load Customer Order Types');
        }
    }

    async function loadProductCategories() {
        var result = await services.GetProductCategoties()
        result.forEach(x => {
            x.productCategoryName = x.productCategoryName == null || x.productCategoryName == "" ? x.categoryCode : x.productCategoryName
        })
        setProductcatogery(result);
    }

    useEffect(() => {
        trackPromise(loadPermissions());
        trackPromise(loadGroups());
        trackPromise(loadProductCategories());
    }, [])

    async function loadPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITCUSTOMERTYPEMAPPING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        const tokenGroupId = parseInt(TokenDecoder.getGroupFactoryToken().group);
        if (!formik.values.groupID || parseInt(formik.values.groupID) < 1) {
            formik.setFieldValue('groupID', tokenGroupId);
        }
    }

    useEffect(() => {

        if (!isPrefillingEditData && editingRowIndex === null) {
            setSelectedProducts([]);
        }
        trackPromise(loadProductsByCategory());
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        trackPromise(loadCustomerOrderTypes());
    }, [])

    async function loadGroups() {
        var res = await services.GetAllGroups();
        if (res != null) {
            setGroupList(res);
        }
    }

    function resetFormAndGrid() {
        const preservedGroupID = parseInt(formik.values.groupID) || 0;

        formik.resetForm({
            values: {
                groupID: preservedGroupID,
                productCategoryID: 0,
                orderTypeIDs: [],
            }
        });
        setSelectedProducts([]);
        setSelectedOrderTypes([]);
        setGridRows([]);
        setDeletedRows([]);
        setEditingRowIndex(null);
        setIsClear(!IsClear);
    }

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;
    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.productCategoryName && option.productCategoryName.toLowerCase().includes(trimmedInput))
        ).filter(option => option.productCategoryName !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.productCategoryName.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });

        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    const getGroupName = (id) => groupList.find((x) => x.groupID === id)?.groupName || '';
    const getOrderTypeName = (id) => orderTypeList.find((x) => x.orderTypeID === id)?.orderTypeName || '';
    const getProductCategoryName = (id) => productcatogery.find((x) => x.productCategoryID === id)?.productCategoryName || '';

    const shouldShowGridAndActions = pageProps.isEdit || gridRows.length > 0 || deletedRows.length > 0;

    const handleAddOrUpdateRow = () => {
        const currentGroupID = parseInt(formik.values.groupID);
        const currentCategoryID = parseInt(formik.values.productCategoryID);
        const currentOrderTypes = selectedOrderTypes;

        if (!currentGroupID || currentGroupID < 1) {
            toast.error('Group is required');
            return;
        }
        if (!currentCategoryID || currentCategoryID < 1) {
            toast.error('Product Category is required');
            return;
        }
        if (!currentOrderTypes || currentOrderTypes.length === 0) {
            toast.error('Customer Order Type is required');
            return;
        }
        if (!selectedProducts || selectedProducts.length === 0) {
            toast.error('Please select at least one product');
            return;
        }

        if (editingRowIndex !== null) {
            if (selectedProducts.length !== 1) {
                toast.error('Please select exactly one product when editing a row');
                return;
            }
            const selected = selectedProducts[0];
            const ot = currentOrderTypes[0];
            setGridRows((prev) => {
                const next = [...prev];
                const existing = next[editingRowIndex];
                if (!existing) return prev;
                next[editingRowIndex] = {
                    ...existing,
                    groupID: currentGroupID,
                    groupName: getGroupName(currentGroupID) || existing.groupName,
                    productCategoryID: currentCategoryID,
                    productCategoryName: getProductCategoryName(currentCategoryID) || existing.productCategoryName,
                    orderTypeID: ot ? ot.orderTypeID : existing.orderTypeID,
                    orderTypeName: ot ? ot.orderTypeName : existing.orderTypeName,
                    productID: selected.productID,
                    productName: selected.productName
                };
                return next;
            });
            setEditingRowIndex(null);
            setSelectedProducts([]);
            setSelectedOrderTypes([]);
            toast.success('Row updated');
            return;
        }

        const rowsToAdd = [];
        for (const p of selectedProducts) {
            for (const ot of currentOrderTypes) {
                rowsToAdd.push({
                    key: `new-${currentGroupID}-${currentCategoryID}-${ot.orderTypeID}-${p.productID}-${Date.now()}`,
                    rowState: 'new',
                    customerTypeMappingID: pageProps.isEdit ? pageProps.editingID : 0,
                    customerTypeProductMappingID: null,
                    groupID: currentGroupID,
                    groupName: getGroupName(currentGroupID),
                    productCategoryID: currentCategoryID,
                    productCategoryName: getProductCategoryName(currentCategoryID),
                    orderTypeID: ot.orderTypeID,
                    orderTypeName: ot.orderTypeName,
                    productID: p.productID,
                    productName: p.productName
                });
            }
        }

        setGridRows((prev) => {
            const existingKeySet = new Set(
                prev.map((r) => `${r.groupID}-${r.productCategoryID}-${r.orderTypeID}-${r.productID}`)
            );
            const filteredNew = rowsToAdd.filter(
                (r) => !existingKeySet.has(`${r.groupID}-${r.productCategoryID}-${r.orderTypeID}-${r.productID}`)
            );
            if (filteredNew.length !== rowsToAdd.length) {
                toast.error('Some selected products were already added');
            }
            return [...prev, ...filteredNew];
        });

        setSelectedProducts([]);
    };

    const handleEditRow = (index) => {
        const row = gridRows[index];
        if (!row) return;
        setEditingRowIndex(index);
        formik.setFieldValue('productCategoryID', row.productCategoryID);
        formik.setFieldValue('orderTypeIDs', [row.orderTypeID]);
        setSelectedOrderTypes([{ orderTypeID: row.orderTypeID, orderTypeName: row.orderTypeName || getOrderTypeName(row.orderTypeID) }]);
        setSelectedProducts([{ productID: row.productID, productName: row.productName }]);
    };

    const handleDeleteRow = (index) => {
        const row = gridRows[index];
        if (!row) return;
        if (row.rowState === 'existing') {
            setDeletedRows((prev) => [...prev, { ...row }]);
        }
        setGridRows((prev) => prev.filter((_, i) => i !== index));
        if (editingRowIndex === index) {
            setEditingRowIndex(null);
            setSelectedProducts([]);
        }
    };

    const handleDeleteRowInEditMode = async (index) => {
        const row = gridRows[index];
        if (!row) return;
        if (!pageProps.isEdit || row.rowState !== 'existing') {
            handleDeleteRow(index);
            return;
        }

        const mappingIdToDelete = row.customerTypeMappingID ?? pageProps.editingID;
        if (!mappingIdToDelete || parseInt(mappingIdToDelete) < 1) {
            toast.error('Selected row has no mapping ID to delete');
            return;
        }

        setDeleteConfirm({ open: true, mappingId: parseInt(mappingIdToDelete), rowIndex: index });
    };

    const closeDeleteConfirm = () => setDeleteConfirm({ open: false, mappingId: 0, rowIndex: null });

    const hasPendingChanges = () => {
        if (!pageProps.isEdit) {
            return Boolean(
                formik.dirty ||
                (gridRows?.length ?? 0) > 0 ||
                (selectedProducts?.length ?? 0) > 0 ||
                (deletedRows?.length ?? 0) > 0 ||
                editingRowIndex !== null
            );
        }

        const originalRows = Array.isArray(prefilledRows) ? prefilledRows : [];

        const currentTypeIds = new Set(
            (selectedOrderTypes || [])
                .map((t) => parseInt(t.orderTypeID, 10))
                .filter((id) => !Number.isNaN(id) && id > 0)
        );
        const originalTypeIds = new Set(
            originalRows
                .map((r) => parseInt(r.orderTypeID, 10))
                .filter((id) => !Number.isNaN(id) && id > 0)
        );

        const addedTypeIds = Array.from(currentTypeIds).filter((id) => !originalTypeIds.has(id));
        const removedTypeIds = Array.from(originalTypeIds).filter((id) => !currentTypeIds.has(id));

        return Boolean(
            addedTypeIds.length > 0 ||
            removedTypeIds.length > 0
        );
    };

    const handleBackClick = () => {
        if (hasPendingChanges()) {
            setBackConfirmOpen(true);
            return;
        }
        navigate('/dashboard/CustomerTypeMapping');
    };

    const closeBackConfirm = () => setBackConfirmOpen(false);

    const confirmBackNavigation = () => {
        setBackConfirmOpen(false);
        navigate('/dashboard/CustomerTypeMapping');
    };

    const confirmDeleteCustomerTypeMapping = async () => {
        const id = parseInt(deleteConfirm.mappingId);
        if (!id || id < 1) {
            toast.error('Selected record has no mapping ID');
            closeDeleteConfirm();
            return;
        }

        try {
            const res = await services.DeleteCustomerTypeMapping(id);
            if (res?.statusCode === 'Success') {
                toast.success(res?.message ?? 'Customer Type Mapping deleted successfully');
                closeDeleteConfirm();
                setTimeout(() => {
                    navigate('/dashboard/CustomerTypeMapping');
                }, 800);
            } else {
                toast.error(res?.message ?? 'Error occured in Customer Type Mapping delete');
            }
        } catch (e) {
            toast.error('Error occured in Customer Type Mapping delete');
        }
    };

    const getSelectedProductsSummary = (selected) => {
        const safeSelected = Array.isArray(selected) ? selected : [];
        if (safeSelected.length === 0) return '';
        const firstLabel = safeSelected[0]?.productName || '';
        const moreCount = safeSelected.length - 1;
        return moreCount > 0 ? `${firstLabel} + ${moreCount} more` : firstLabel;
    };

    return (
        <>
            <LoadingComponent />
            <Page title={`${pageProps.pageName} |  FAPS`}>
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/CustomerTypeMapping"}
                        btname="Back"
                        pageName={pageProps.pageName}
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="flex-end" mb={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleBackClick}
                                startIcon={<Icon>backspaceIcon</Icon>}
                            >
                                Back
                            </Button>
                        </Stack>
                        <Dialog
                            open={backConfirmOpen}
                            onClose={closeBackConfirm}
                            aria-labelledby="customer-type-mapping-back-confirm-title"
                        >
                            <DialogTitle id="customer-type-mapping-back-confirm-title">
                                Discard changes?
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure you want to go back? Any unsaved changes will be lost.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={closeBackConfirm} color="inherit">
                                    Cancel
                                </Button>
                                <Button onClick={confirmBackNavigation} color="primary" variant="contained">
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={deleteConfirm.open}
                            onClose={closeDeleteConfirm}
                            aria-labelledby="customer-type-mapping-delete-dialog-title"
                        >
                            <DialogTitle id="customer-type-mapping-delete-dialog-title">
                                Delete Customer Type Mapping
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure you want to delete this Customer Type Mapping?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={closeDeleteConfirm} color="inherit">
                                    Cancel
                                </Button>
                                <Button onClick={() => trackPromise(confirmDeleteCustomerTypeMapping())} color="error" variant="contained">
                                    OK
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: pageProps.isEdit || !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <Autocomplete
                                            key={IsClear}
                                            fullWidth
                                            id="productCategoryID"
                                            disabled={pageProps.isEdit}
                                            options={productcatogery}
                                            filterOptions={filterOptions}
                                            getOptionLabel={(option) => option.productCategoryName || ''}
                                            getOptionSelected={(option, value) => option.productCategoryID === value.productCategoryID}
                                            value={productcatogery.find(option => option.productCategoryID === formik.values.productCategoryID) || null}
                                            onChange={(e, value) => formik.setFieldValue('productCategoryID', value ? value.productCategoryID : 0)}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    variant="outlined"
                                                    name="productCategoryID"
                                                    label="Product Category *"
                                                    size="small"
                                                    fullWidth
                                                    helperText={formik.touched.productCategoryID && formik.errors.productCategoryID}
                                                    error={Boolean(formik.touched.productCategoryID && formik.errors.productCategoryID)}
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <Autocomplete
                                            fullWidth
                                            key={IsClear}
                                            multiple
                                            disableCloseOnSelect
                                            id="productIDs"
                                            disabled={pageProps.isEdit}
                                            options={[{ productID: -1, productName: 'Select All' }, ...product]}
                                            getOptionLabel={(option) => option.productName || ''}
                                            isOptionEqualToValue={(option, value) => option.productID === value.productID}
                                            value={selectedProducts}
                                            onChange={(e, value) => {
                                                if (value.some((v) => v.productID === -1)) {
                                                    setSelectedProducts(selectedProducts.length === product.length ? [] : [...product]);
                                                } else {
                                                    setSelectedProducts(value || []);
                                                }
                                            }}
                                            renderOption={(props, option, { selected }) => {
                                                if (option.productID === -1) {
                                                    const allSelected = selectedProducts.length === product.length;
                                                    return (
                                                        <li {...props}>
                                                            <Checkbox
                                                                color="primary"
                                                                checked={allSelected}
                                                                indeterminate={selectedProducts.length > 0 && !allSelected}
                                                                style={{ marginRight: 8 }}
                                                            />
                                                            Select All
                                                        </li>
                                                    );
                                                }
                                                return (
                                                    <li {...props}>
                                                        <Checkbox color="primary" checked={selected} style={{ marginRight: 8 }} />
                                                        {option.productName}
                                                    </li>
                                                );
                                            }}
                                            renderTags={(value) => {
                                                const label = getSelectedProductsSummary(value);
                                                return label ? <Chip key="selected-products-summary" label={label} size="small" /> : null;
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    name="productIDs"
                                                    label="Product *"
                                                    size="small"
                                                    fullWidth
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Stack>

                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <Autocomplete
                                            fullWidth
                                            key={IsClear}
                                            multiple
                                            disableCloseOnSelect
                                            id="orderTypeIDs"
                                            options={[{ orderTypeID: -1, orderTypeName: 'Select All' }, ...orderTypeList]}
                                            getOptionLabel={(option) => option.orderTypeName || ''}
                                            isOptionEqualToValue={(option, value) => option.orderTypeID === value.orderTypeID}
                                            value={selectedOrderTypes}
                                            onChange={(e, value) => {
                                                let next;
                                                if (value.some((v) => v.orderTypeID === -1)) {
                                                    next = selectedOrderTypes.length === orderTypeList.length ? [] : [...orderTypeList];
                                                } else {
                                                    next = value || [];
                                                }
                                                setSelectedOrderTypes(next);
                                                formik.setFieldValue('orderTypeIDs', next.map((v) => v.orderTypeID));
                                            }}
                                            renderOption={(props, option, { selected }) => {
                                                if (option.orderTypeID === -1) {
                                                    const allSelected = selectedOrderTypes.length === orderTypeList.length;
                                                    return (
                                                        <li {...props}>
                                                            <Checkbox
                                                                color="primary"
                                                                checked={allSelected}
                                                                indeterminate={selectedOrderTypes.length > 0 && !allSelected}
                                                                style={{ marginRight: 8 }}
                                                            />
                                                            Select All
                                                        </li>
                                                    );
                                                }
                                                return (
                                                    <li {...props}>
                                                        <Checkbox color="primary" checked={selected} style={{ marginRight: 8 }} />
                                                        {option.orderTypeName}
                                                    </li>
                                                );
                                            }}
                                            renderTags={(value) => {
                                                if (!value || value.length === 0) return null;
                                                const firstName = value[0]?.orderTypeName || '';
                                                const more = value.length - 1;
                                                return (
                                                    <Chip
                                                        key="order-types-summary"
                                                        label={more > 0 ? `${firstName} +${more} more` : firstName}
                                                        size="small"
                                                    />
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label="Customer Order Type *"
                                                    size="small"
                                                    fullWidth
                                                    error={Boolean(touched.orderTypeIDs && errors.orderTypeIDs)}
                                                    helperText={touched.orderTypeIDs && errors.orderTypeIDs}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item md={8} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="flex-end" spacing={2} style={{ width: '100%' }}>
                                             {!pageProps.isEdit && (
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={() => resetFormAndGrid()}
                                                    disabled={isButtonEnable || gridRows.length > 0}
                                                >
                                                    Clear
                                                </Button>
                                            )}
                                            
                                            {(!pageProps.isEdit || editingRowIndex !== null) && (
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleAddOrUpdateRow}
                                                    disabled={isButtonEnable}
                                                >
                                                    {editingRowIndex !== null ? 'Update Row' : 'Add'}
                                                </Button>
                                            )}
                                        </Stack>
                                    </Grid>
                                </Stack>

                                {shouldShowGridAndActions && (
                                    <>
                                        {!pageProps.isEdit && editingRowIndex === null && (
                                            <TableContainer component={Paper}>
                                                <Table size="small" aria-label="customer-type-mapping-grid">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left">Group</TableCell>
                                                            <TableCell align="left">Product Category</TableCell>
                                                            <TableCell align="left">Product</TableCell>
                                                            <TableCell align="left">Customer Order Type</TableCell>
                                                            <TableCell align="center">Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {gridRows.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={5} align="center">
                                                                    No records added
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            gridRows.map((row, index) => (
                                                                <TableRow key={row.key || index}>
                                                                    <TableCell align="left">{row.groupName || getGroupName(row.groupID)}</TableCell>
                                                                    <TableCell align="left">{row.productCategoryName || getProductCategoryName(row.productCategoryID)}</TableCell>
                                                                    <TableCell align="left">{row.productName}</TableCell>
                                                                    <TableCell align="left">{row.orderTypeName || getOrderTypeName(row.orderTypeID)}</TableCell>
                                                                    <TableCell align="center">
                                                                        <IconButton aria-label="edit" onClick={() => handleEditRow(index)}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                        <IconButton aria-label="delete" onClick={() => trackPromise(handleDeleteRowInEditMode(index))}>
                                                                            <DeleteIcon color="error" />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                           
                                            {editingRowIndex === null && (
                                                <Button
                                                    disabled={isButtonEnable}
                                                    type="submit"
                                                    variant="contained"
                                                    color="secondary"
                                                >
                                                    {pageProps.submitButtonName}
                                                </Button>
                                            )}
                                        </Stack>
                                    </>
                                )}
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}

